import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

const IconCardsSVG = ({color, className, ...rest}) => {
    return (
        <svg {...rest} width="24" height="24" viewBox="0 0 24 24"
             className={classNames(['svg-icon svg-cards', className])}>
                <path d="M0,0H24V24H0Z" fill="none"/>
                <path fill={color}
                      d="M4,13h6a1,1,0,0,0,1-1V4a1,1,0,0,0-1-1H4A1,1,0,0,0,3,4v8A1,1,0,0,0,4,13Zm0,8h6a1,1,0,0,0,1-1V16a1,1,0,0,0-1-1H4a1,1,0,0,0-1,1v4A1,1,0,0,0,4,21Zm10,0h6a1,1,0,0,0,1-1V12a1,1,0,0,0-1-1H14a1,1,0,0,0-1,1v8A1,1,0,0,0,14,21ZM13,4V8a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V4a1,1,0,0,0-1-1H14A1,1,0,0,0,13,4Z"/>
        </svg>

    );
};

IconCardsSVG.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

IconCardsSVG.defaultProps = {
    color: '#ffffff',
    className: '',
};

export default IconCardsSVG;